import './css/common.scss';
import 'react-toastify/dist/ReactToastify.css';

import {Route, BrowserRouter as Router,Switch,/*,Link*/
BrowserRouter} from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import Login from './components/login/Login';
import SubmissionTool from './components/submissionTool/SubmissionTool';
import Dashboard from './components/dashboard/Dashboard';
import PSDashboard from './components/dashboard/PSDashboard';
import PSDetailDashboard from './components/dashboard/PSDetailDashboard';
import DetailDashboard from './components/dashboard/DetailDashboard';
import EditReport from './components/reports/EditReport/EditReport';
import SectorEditReport from './components/reports/EditReport/SectorEditReport';
import CompleteAuth from './components/CompleteAuth/CompleteAuth';
import ConfigService from './shared/configService';
import AuthService from './shared/authService';
import CookieService from './shared/cookieService';
import ContextService from './shared/contextService';
import { createBrowserHistory } from "history";
import Constants from './shared/constants';

const App = () => {

  const history = createBrowserHistory()

  /**
     * State
     */
   const [state, setState] = useState({
    configLoaded: false,
    userLoaded: false
   })
  
  /**
   * Effect
  */
   useEffect(() => {    
    //Init services
    ContextService.initInstance();
    CookieService.initInstance();
    ConfigService.loadConfig()
    .then(() => {      
      AuthService.initInstance();
      setState({
        userLoaded: AuthService.checkConnectedUser(),
        configLoaded: ConfigService.getConfig().agol && ConfigService.getConfig().agol.portalURL !== undefined
      });
    });
  }, []);

  /**
   * Handle close app
   */
  useEffect(() => {
    window.onbeforeunload = (ev: any) => {
      ev.preventDefault()
      if (window.localStorage.getItem(Constants.IUCN_KEEP_SIGNED_IN) !== 'on') {
        CookieService.getInstance().destroyCookie();
      }
    }
  }, [])

  /**
   * Get redirect path
   */
  const getRedirectPath = (): string => {
    if(history && history.location && history.location.pathname) {
      return `${history.location.pathname}${history.location.search && history.location.search}`;
    }

    return ConfigService.getConfig().routes?.submissionTool.reports || '';
  }

  /**
   * Check is dashboard
   * @returns
   */
  const isDashboardPath = () => {    
    return history.location.pathname && 
      (history.location.pathname.indexOf(ConfigService.getConfig().routes.dashboard) != -1 || 
      history.location.pathname.indexOf(ConfigService.getConfig().routes.detaildashboard) != -1 ||
      history.location.pathname.indexOf(ConfigService.getConfig().routes.completeAuth) != -1||
      history.location.pathname.indexOf(ConfigService.getConfig().routes.psdashboard) != -1 ||
      history.location.pathname.indexOf(ConfigService.getConfig().routes.psdetaildashboard) != -1
      );
      
  }

  return (    
    <Router>
      <div className="App">
      
        { state.configLoaded && 
        <div>
          <Switch>
              <Route path={ConfigService.getConfig().routes?.login}>
                <Login />
              </Route>
              
              <Route path={ConfigService.getConfig().routes?.submissionTool.reports}>
                <SubmissionTool />
              </Route>

              <Route path={ConfigService.getConfig().routes?.submissionTool.editReport}>
                <EditReport />
              </Route>

              <Route path={ConfigService.getConfig().routes?.submissionTool.sectoreditReport}>
                <SectorEditReport />
              </Route>
              
              <Route path={ConfigService.getConfig().routes?.dashboard}>
                <Dashboard />
              </Route>

              <Route path={ConfigService.getConfig().routes?.psdashboard}>
              <PSDashboard />
              </Route>

              <Route path={ConfigService.getConfig().routes?.psdetaildashboard}>
              <PSDetailDashboard />
              </Route>

              <Route path={ConfigService.getConfig().routes?.detaildashboard}>
                <DetailDashboard />
              </Route>

              <Route path={ConfigService.getConfig().routes?.completeAuth}>
                <CompleteAuth />
              </Route>

          </Switch>

          {isDashboardPath() || state.userLoaded ?
          <Redirect to={getRedirectPath()}/>
          :
          <Redirect to={ConfigService.getConfig().routes?.login || ''} />
          }
        </div>
        }
      </div>      
    </Router>

  );
}

export default App;
